export function Each<T>(props: {
  data: T[];
  render: (item: T, index: number) => React.JSX.Element;
}) {
  return props.data.map(props.render);
}
